import { Component, OnDestroy, Inject, OnInit, ViewChild } from '@angular/core';
import { SuiModal, ComponentModalConfig, ModalSize, DatepickerMode } from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil, delay, map, tap, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SharedValidators } from 'src/modules/shared';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from 'src/modules/core/services';
import { OrganizationService } from 'src/modules/features/admin/services';
interface ICompanyInfoModalContext {
	data: any;
	title?: string;
}
@Component({
	selector: 'app-company-info-modal',
	templateUrl: './company-info-modal.component.html',
	styleUrls: [ './company-info-modal.component.scss' ]
})
export class CompanyInfoModalComponent implements OnInit, OnDestroy {
	@ViewChild('captchaRef') refCapt;
	private unsubscribe$: Subject<void> = new Subject<void>();
	companyDetail: any;
	success: any;

	public loginPending: boolean;
	public detailForm: FormGroup;
	public pending: boolean;
	public formSubmitAttempt = false;
	public bppDetail: any;
	public error: any;
	public countries: any;
	public states: any;
	public mode = 'date';
	public max = new Date();

	public companyEmailLoading = false;
	public usernameLoading = false;
	public emailLoading = false;

	usernameError = true;
	usernameServerError;

	emailError = true;
	emailServerError;

	companyEmailError = true;
	companyEmailServerError;

	companyType;
	ownershipType;

	companyTypeObj;
	ownershipTypeObj;
	state;
	country;

	optionFilter = {
		groupOp: 'OR',
		rules: [
			{
				field: 'optionType.optionTypeId',
				op: 'eq',
				data: 'ownership_type'
			},
			{
				field: 'optionType.optionTypeId',
				op: 'eq',
				data: 'actual_company_type'
			},
			{
				field: 'optionType.optionTypeId',
				op: 'eq',
				data: 'foreign_company_providers'
			}
		]
	};

	collapseCompanySection = false;
	foreignObj;
	selectedCountry = 'NG';
	selectedState = '19';
	oldDetails: any;
	userObject;
	organizationId: string;
	organization;
	organizationss;
	ownership;
	foreign = true;
	constructor(
		@Inject(DOCUMENT) private document,
		private fb: FormBuilder,
		public modal: SuiModal<ICompanyInfoModalContext, void, void>,
		private http: HttpClient,
		private organizationSvc: OrganizationService
	) {
		this.organizationId = window.localStorage.getItem('organizationId');
		this.organization = JSON.parse(window.localStorage.getItem('organization'));
		console.log(this.organization);
		this.userObject = this.organization['jpaContractor'];
		this.state = this.organization['jpaContractor']['headOfficeAddressState']['stateId'];
		this.country = this.organization['jpaContractor']['countryOfRegistration']['countryCode'];
		this.ownership = this.organization['jpaContractor']['ownershipType']['optionId'];

		if (this.ownership === 'foreign_owned') {
			this.foreign = false;
		}
		// this.getContractor();
		this.getOptionTypes();
		this.getCountry();
		this.getStates();

		this.detailForm = this.fb.group({
			zipcode: [ '' ],
			actualCompanyType: [ '' ],
			headOfficeAddressCity: [ '' ],
			headOfficeAddressPobox: [ '' ],
			headOfficeAddressPmb: [ '' ],
			headOfficeAddressZip: [ '' ],
			headOfficeAddressState: [ '' ],
			countryOfRegistration: [ '', [ Validators.required ] ],
			headOfficeAddressStreet: [ '' ],
			companyContactEmail: [ '', [ Validators.required, SharedValidators.email ] ],
			companyContactAlternativeEmail: [ '' ],
			companyName: [ '' ],
			companyType: [ '' ],
			companyContactPhone1: [ '' ],
			companyContactPhone2: [ '' ],
			dateOfRegistration: [ '' ],
			mobileNumber: [ '' ],
			officePhone: [ '' ],
			alternativeMail: [ '' ],
			tinNumber: [ '' ],
			rcNumber: [ '' ],
			website: [ '' ],
			registrationNumber: [ '' ]
		});
		this.detailForm.patchValue(this.userObject);
		this.detailForm.patchValue({
			headOfficeAddressState: this.userObject['headOfficeAddressState']['stateId'],
			countryOfRegistration: this.userObject['countryOfRegistration']['countryCode']
		});

		this.detailForm
			.get('companyContactEmail')
			.valueChanges.pipe(
				tap((value) => {
					if (value && value !== '' && value !== this.organization.companyContactEmail) {
						this.companyEmailLoading = true;
						this.companyEmailError = true;
						this.companyEmailServerError = false;
					}
				}),
				delay(800),
				debounceTime(800),
				distinctUntilChanged()
			)
			.subscribe((value) => {
				if (value && value !== '' && value !== this.organization.companyContactEmail) {
					this.http.get(`${environment.API_SERVER}/auth/company-email-availablity/${value}/`).subscribe(
						(res) => {
							this.companyEmailLoading = false;
							this.companyEmailError = res['status'];
						},
						(error) => {
							this.companyEmailLoading = false;
							if (error['status'] !== 404) {
								this.companyEmailServerError = false;
							} else {
								this.companyEmailServerError = true;
							}
						}
					);
				}
			});
	}

	getContractor() {
		// this.organizationSvc.getContractor({ organizationId: this.organizationId }).subscribe((res) => {
		// 	console.log(res);
		// 	this.organization = res['jpaContractor'];
		// 	this.userObject = res['jpaContractor'];
		// 	this.state = res['jpaContractor']['headOfficeAddressState']['stateId'];
		// 	console.log(this.state);
		// 	this.country = res['jpaContractor']['countryOfRegistration']['countryCode'];
		// 	console.log(this.country);
		// 	this.ownership = res['jpaContractor']['ownershipType']['optionId'];
		// 	console.log(this.ownership);
		// 	if (this.ownership === 'foreign_owned') {
		// 		this.foreign = false;
		// 	}
		// 	console.log(this.organization);
		// });
	}

	getCountry() {
		this.organizationSvc.getCountries({ organizationId: this.organizationId }).subscribe((res) => {
			this.countries = res['rows'];
		});
	}

	getStates() {
		this.organizationSvc.getStates({ filter: '' }).subscribe((res) => {
			this.states = res['rows'];
		});
	}

	cancel() {
		this.formSubmitAttempt = false;
		window.location.reload();
	}

	isFieldValid(field: string) {
		return (
			(!this.detailForm.get(field).valid && this.detailForm.get(field).touched) ||
			(this.detailForm.get(field).untouched && this.formSubmitAttempt)
		);
	}

	displayFieldCss(field: string) {
		return {
			error: this.isFieldValid(field)
		};
	}

	displayFormCss(field: string) {
		return {
			loading: field
		};
	}

	ngOnInit() {}

	save() {
		this.error = null;
		this.success = null;
		this.formSubmitAttempt = false;
		if (this.detailForm.valid && this.companyEmailError) {
			this.pending = true;

			this.userObject.countryOfRegistration = this.countries.filter(
				(res) => res.countryCode === this.detailForm.value.countryOfRegistration
			)[0];
			this.userObject.headOfficeAddressState = this.states.filter(
				(res) => res.stateId === this.detailForm.value.headOfficeAddressState
			)[0];
			this.userObject.headOfficeAddressCity = this.detailForm.value.headOfficeAddressCity;
			this.userObject.headOfficeAddressZip = this.detailForm.value.headOfficeAddressZip;
			this.userObject.headOfficeAddressPmb = this.detailForm.value.headOfficeAddressPmb;
			this.userObject.website = this.detailForm.value.website;
			this.userObject.companyContactPhone1 = this.detailForm.value.companyContactPhone1;
			this.userObject.companyContactPhone2 = this.detailForm.value.companyContactPhone2;
			this.userObject.companyContactEmail = this.detailForm.value.companyContactEmail;
			this.userObject.companyContactAlternativeEmail = this.detailForm.value.companyContactAlternativeEmail;

			// this.userObject.dateOfRegistration = this.detailForm.value.dateOfRegistration;
			this.organizationSvc
				.updateOrganization({ organizationId: this.organizationId, body: this.userObject })
				.pipe(takeUntil(this.unsubscribe$))
				.subscribe(
					(res: any) => {
						this.pending = false;
						this.success = 'Organization detail updated successfully';
						setTimeout(() => {
							this.modal.approve(res);
						}, 2000);
					},
					(error) => {
						this.pending = false;
						this.error = error.error;
					}
				);
		} else {
			this.formSubmitAttempt = true;
		}
	}

	ngOnDestroy() {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

	getOptionTypes() {
		// this.optionError = false;
		// this.optionLoading = true;
		this.organizationSvc
			.getOptions({ filter: JSON.stringify(this.optionFilter) })
			.pipe(
				takeUntil(this.unsubscribe$),
				map((res: any) => res['rows']),
				map((res: any) => {
					const options = { ownershipType: [], companyType: [], errorOption: [], providerType: [] };
					res.forEach((option) => {
						// console.log(option)
						switch (option.optionType.optionTypeId) {
							case 'ownership_type':
								options.ownershipType.push(option);
								break;
							case 'actual_company_type':
								options.companyType.push(option);
								break;
							case 'foreign_company_providers':
								options.providerType.push(option);
								break;
							default:
								options.errorOption.push(option);
						}
					});
					return options;
				})
			)
			.subscribe(
				(res) => {
					// this.optionLoading = false;
					this.companyType = res.companyType;
					this.ownershipType = res.ownershipType;
					// this.bizProvider = res.providerType;
				},
				(error) => {
					// console.log(error)
					// this.optionError = true;
					// this.optionLoading = false;
				}
			);
	}
}
export class CompanyInfoModal extends ComponentModalConfig<ICompanyInfoModalContext, void, void> {
	constructor(title: string, data: any, size: ModalSize = ModalSize.Small) {
		super(CompanyInfoModalComponent, { title, data });

		this.isClosable = false;
		this.transitionDuration = 200;
		this.transition = 'slide left';
		this.size = size;
		this.isFullScreen = false;
		this.isInverted = false;
	}
}
